<template>
  <div class="custom-autocomplete">
    <label class="data-label">
      {{ label }}
    </label>
    <autocomplete
      :search="search"
      :placeholder="placeholder"
      :get-result-value="getResultValue"
      :debounce-time="debounceTime"
      :auto-select="true"
      @submit="$emit('submit', $event)"
      class="custom-autocomplete__input"
      :disabled="disabled"
      ref="autocompleteRef"
      @input="onChangeHandler"
    >
      <template #result="{ result, props }">
        <li
          v-bind="props"
          class="custom-autocomplete__result"
          v-if="!showCustomUserTemplate"
        >
          <div class="custom-autocomplete__result__title cursor-pointer">
            {{ result[displayTextName] }}
          </div>
        </li>
        <li v-bind="props" class="custom-autocomplete__custom-result" v-else>
          <div class="d-flex align-items-center cursor-pointer">
            <em class="fa fa-user-circle font-28 color-gray-14" />
            <div class="flex-flex-grow-1 ml-3">
              <div class="color-black font-14 font-weight-bold">
                {{ result.fullName | capitalize }}
              </div>
              <div class="color-gray-6 font-14 font-italic">
                {{ result.roleName | capitalize }} / {{ result.userName }}
              </div>
            </div>
          </div>
        </li>
      </template>
    </autocomplete>
    <div
      class="custom-autocomplete__clear cursor-pointer"
      @click="onClearHandler"
      v-if="inputValue && showClear"
    >
      <em class="fas fa-times-circle" />
    </div>
  </div>
</template>

<script>
import Autocomplete from '@trevoreyre/autocomplete-vue';
export default {
  name: 'CustomAutoComplete',
  components: {
    Autocomplete,
  },
  props: {
    disabled: {
      type: Boolean,
      default: () => false,
    },
    search: {
      type: Function,
      required: true,
    },
    getResultValue: {
      type: Function,
      default: () => {},
    },
    debounceTime: {
      type: Number,
      default: () => 0,
    },
    placeholder: {
      type: String,
      default: () => '',
    },
    displayTextName: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: () => '',
    },
    showCustomUserTemplate: {
      type: Boolean,
      deafult: () => false,
    },
    showClear: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    inputValue: null,
  }),
  methods: {
    onChangeHandler(event) {
      this.inputValue = event.target.value;
    },
    onClearHandler() {
      this.$refs.autocompleteRef.value = null;
      this.inputValue = null;
    },
    showClearText() {},
  },
};
</script>

<style scoped lang="scss">
.custom-autocomplete {
  &__input {
    ::v-deep {
      .autocomplete {
        &::before {
          font-family: 'Font Awesome 5 Pro';
          content: '\f002';
          color: #ff7058;
          font-weight: bold;
          position: absolute;
          z-index: 2;
          top: 9px;
          left: 11px;
        }
        input {
          height: 36px;
          background: #fff;
          border: 1px solid #c5cdcf;
          border-radius: 5px;
          padding-left: 38px;
          &::placeholder {
            color: #727272;
            opacity: 1;
            font-size: 15px;
          }
        }
        li {
          background-image: unset;
          padding-left: 20px;
        }
      }
    }
  }
  &__result {
    border: 1px solid #e2e2e2;
    padding: 20px 0 20px 0;
    &__title {
      color: #11291b;
    }
  }
  &__custom-result {
    border: 1px solid #f2f2f2;
  }
  &__clear {
    position: absolute;
    top: 37px;
    right: 28px;
    color: #aaaaaa;
  }
}
</style>
